import {connect} from 'react-redux'
import ListPaginationView from '../components/ListPaginationView'
import _ from 'lodash'

const mapDispatchToProps = {

};

const mapStateToProps = (state, ownProps) => {

  const hasItems = ownProps.items && ownProps.items.length;

  const columns = ownProps.columns || 1;
  const itemsPerPage = (ownProps.itemsPerPage || 5) * columns;

  const totalPages = hasItems ? Math.ceil(ownProps.items.length / itemsPerPage) : 0;

  return {
    hasItems: hasItems,
    items: ownProps.items || [],
    columns: columns,
    itemsPerPage: itemsPerPage,
    totalPages: totalPages,
    noItemsMessage: ownProps.noItemsMessage || '',
    showPagination: hasItems && ownProps.items.length > itemsPerPage,
    horizontal: ownProps.horizontal,
    searchTerm: state.products.searchTerm
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ListPaginationView)


// WEBPACK FOOTER //
// ./src/components/shared/ListPagination/containers/ListPaginationContainer.js